import {
  searchListings
} from "./chunk-MPUZIXB6.js";
import {
  mapOptionsToSearchListingsParams
} from "./chunk-POZ5IQ74.js";
import {
  getConfigWithMetadata
} from "./chunk-NFLWKIRZ.js";
import {
  mapSearchListingsFiltersToSearchFilterRequest
} from "./chunk-KLW2VFR7.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/searchListings/searchListings.ts
async function searchListings2(filters, options, apiConfig) {
  const _apiConfig = getConfigWithMetadata(apiConfig, "searchListings");
  const params = mapOptionsToSearchListingsParams(options);
  const appliedFilters = mapSearchListingsFiltersToSearchFilterRequest(filters, options);
  try {
    const data = await searchListings(appliedFilters, params, _apiConfig);
    return {
      status: "success",
      data,
      metadata: { appliedFilters }
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error, { appliedFilters });
  }
}

export {
  searchListings2 as searchListings
};
